<template>
  <custom-callout
    border-color="primary-2"
    class="mb-4 custom-callout rounded"
    :has-toggle="false"
  >
    <div class="py-1">
      <div class="d-flex">
        <icon-view
          class="mt-5 mb-2 mt-md-3 mt-sm-5 ml-4"
          :gradient="false"
          icon="fas fa-user-tag mb-1"
          icon-background="#ffff"
          icon-color="#ff7058"
          icon-size="15px"
          :title="title"
        />
      </div>
      <div class="pl-4">
        <validation-observer ref="userObserver">
          <div class="row my-3">
            <div class="col-md-3 col-sm-12">
              <validation-provider
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'El nombre o email del usuario es requerido.',
                }"
                rules="required"
              >
                <custom-input
                  v-model="nameOrEmail"
                  class="mt-2"
                  :error="errors[0]"
                  :left-icon="true"
                  icon='fa fa-search color-orange'
                  placeholder="Escriba nombre o email del usuario"
                />
              </validation-provider>
            </div>

            <div class="col-md-3 col-sm-12  pt-2 ">
              <div class="mt-0">
                <action-button
                  i="fas fa-search"
                  text="Buscar"
                  variant="success pl-3 pr-3 mr-3"
                  @click="searchStudent"
                />
                <action-button
                  v-if="!showStudendSection"
                  i="fas fa-times-circle"
                  text="Cerrar"
                  variant="outline-danger pl-3 pr-3"
                  @click="onClose"
                />
              </div>
            </div>
          </div>
        </validation-observer>

        <div >
          <div class="row" v-if="result.data.length>0">
            <div class="col-md-12 text-bold bold mb-3 mt-2">
              <i class=" fa fa-info-circle color-orange" />
             Resultados Relacionados
            </div>

            <div  v-for="(item, index) in result.data" :key="index" class="col-md-12 text-bold bold mb-3 mt-2 pr-5">
              <div class="container-student pb-3 pl-3">
                <div class="row">
                  <div class="col-12 col-md-2 pt-4">
                    <div class=" ml-2 regular text-gray">
                      Nombre del Usuario:
                    </div>
                    <div class=" ml-2 regular color-black">
                     {{ item.fullname }}
                    </div>
                  </div>
                  <div class="col-12 col-md-2 pt-4">
                    <div class=" ml-2 regular text-gray">
                      Usuario:
                    </div>
                    <div class=" ml-2 regular color-black">
                      {{item.username}} 
                    </div>
                  </div>
                  <div class="col-12 col-md-2 pt-4">
                    <div class=" ml-2 regular text-gray">
                      Correo Electrónico:
                    </div>
                    <div class=" ml-2 regular color-black">
                       {{item.email}} 
                    </div>
                  </div>
                  <div class="col-12 col-md pt-4">
                    <div class=" ml-2 regular text-gray">
                    Rol:
                    </div>
                    <div class=" ml-2 regular color-black">
                      {{item.rolenames}}
                    </div>
                  </div>
                  
                  <div class="col-12 col-md pt-4">
                    <div class=" ml-2 regular text-gray">
                      Estatus:
                    </div>
                    <div class=" ml-2 regular color-black ">
                      <div class="row">
                      
                        <div class="col-5 d-flex justify-content-start">
                         <span class="activity-indicator mr-2"
                           :class="[item.isActive ? 'active' : 'inactive']">
                         </span>
                         {{item.isActive?'Activo':'Inactivo'}}
                       </div>
                       <!-- <div class="col-6 d-flex justify-content-start">  {{item.isActive?'Activo':'Inactivo'}}</div>-->
                      </div>
              
                    </div>
                  </div>
                  <div class="col-12 col-md">
                        <action-button
                          style="min-width: 126px;"
                          :disabled="hasConsolidated"
                          @click="consolidateUser(item)"
                          variant="success float-right mr-3 mt-4"
                          text="Consolidar"
                          i="fas fa-exchange-alt"
                        />
                    </div>
                </div>
              </div>
            </div>
           
          </div>
          <pagination
          v-if="showPagination"
          class="mr-3"
          :show-text="false"
          @pagination-go-page="goToPageHandler"
          :data="result.pagination"
        />
        
        </div>
      </div>
      <br />
    </div>
    
  </custom-callout>
</template>
<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import IconView from 'icon-view';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { getUsersSearchResults, consolidateUserAccount} from '@/modules/users/api';
import alert from 'utils/mixins/alert.mixin';
import Pagination from 'Pagination';
export default {
  name: 'SearchUser',
  components: {
    IconView,
    ActionButton,
    CustomInput,
    CustomCallout,
    Pagination,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [alert],
  props: {
    defaultComment: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      required: true,
    },
    userAccount: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
    hasConsolidated: false,
    nameOrEmail:null,
     result: {
        data: [],
        pageNumber:1,
        pagination: {
          totalItemCount: 0,
          count: 15,
          pageCount: 0,
          currentPage: 1,
        },
  
  },
    }
    }, 

  computed:{  
  showPagination() {
      return this.result.pagination.totalItemCount > this.result.pagination.count;
    },
  },
  methods: {
    onClose() {
      this.$emit('on-close');
      this.showStudendSection = false;
    },
    async onContinue() {
      this.uploadData();
      this.$emit('on-continue');
    },
    async searchStudent() {
   const isValid = await this.$refs.userObserver.validate()
   if(isValid){
let  payload= {
          filterCriteria:this.nameOrEmail,
          pageNumber: this.pageNumber,
          pageSize: 3,
        }
      const {data} = await getUsersSearchResults(payload);
       this.result = {
        ...this.result,
        data: data.data,
        pagination: {
          ...this.result.pagination,
          ...data
        },
      };
      if (this.result.data.length==0){
   this.Toast(
        "Error",
        `El nombre o email del usuario no se encontró en sistema.`,
        "error"
      );
      }
   }
    
  
      
    },
    async consolidateUser(item) {
      if(this.hasConsolidated)
        return;

      const userAccount = this.userAccount ?? {};
      const userFullName = `${userAccount.name} ${userAccount.paternalLastName} ${userAccount.maternalLastName}`.trim();
      const consolidateUserFullName = item.fullname.trim();
      const answer = await this.ShowCancelModal('Consolidar',`¿Está seguro que desea consolidar el usuario ${consolidateUserFullName} en ${userFullName}? Esta acción eliminará de forma permanente el usuario ${consolidateUserFullName}`)
      
      if(answer){
        const { data: success } = await consolidateUserAccount(userAccount.userId, item.userId);
        if (!success) {
          this.Toast(
            'Error',
            'Ocurrio un error consolidando las cuentas de usuario.',
            'error'
          );

          this.hasConsolidated = false;
          return;
        }
        
        this.hasConsolidated = true;
        this.Toast(
          'Exito',
          'Se han consolidado las cuentas exitosamente.',
          'success'
        );
      }
    },
    goToPageHandler(page){
      this.pageNumber=page
      this.searchStudent()
    }
  },
};
</script>
<style scoped lang="scss">
.container-student {
  border-radius: 5px;
  border-left: 5px solid #b5c3bc;
  background-color: white;
}
.container-modal {
  border-radius: 5px;
  background-color: #f2f2f2;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}
.pr-33-px {
  padding-right: 33px;
}
.activity-indicator{
    height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
  margin-top: 6px;
}
.activity-indicator.active {
  
  background-color: #d0ffd5;

}

.activity-indicator.inactive {
  
  background-color: #b5c3bc;

}
</style>
